package analytics

data class AnalyticsConfig(
    val apiKey: String,
    val host: String = "https://eu.i.posthog.com",
    val appName: String = "app",
    val enabled: Boolean = true,
    val debug: Boolean = false,
    val flushIntervalMs: Long = 10_000,
    val batchSize: Int = 20,
    val defaultProperties: Map<String, Any?> = emptyMap(),
    val logger: AnalyticsLogger = AnalyticsLogger.None,
)
